import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeBank from '../components/HomeBank.vue'
import Login from '../components/Login.vue'
import Welcome from '../components/WelCome.vue'
import OrgList from '../components/org/OrgList.vue'
import PaymentExamine from '../components/org/PaymentExamine.vue'
Vue.use(VueRouter)

const routes = [
  { path: '/login', component: Login },
  {
    path: '/home',
    component: HomeBank,
    redirect: '/welcome',
    children: [{ path: '/welcome', component: Welcome }, { path: '/orgList', component: OrgList }, { path: '/paymentExamine', component: PaymentExamine }]
  }
  // {
  // path: '/login',
  // name: 'login',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // debugger
  if (to.path === '/login') return next()
  if (to.path === '/') return next('/home')
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  // console.log(isLogin)
  let token
  if (!(userInfo === null)) {
    token = userInfo
  }
  if (!token) return next('/login')
  next()
})

export default router
